export enum SERVICE_TYPES {
  PRIMARY_CARE = 'primaryCare',
  SPECIALIST_CARE = 'specialistCare',
}

export enum DRUG_TYPES {
  NON_FORMULARY_DRUG = 'nonFormularyDrug',
}

export const currentPlanYearCodes = ['active-new', 'active-qle', 'active-current'];

export enum PAYMENT_TYPES {
  Copay = 'Copay',
  Coins = 'Coinsurance',
  CoinsWithLimits = 'Coinsurance with Limits',
  CopayThenCoins = 'Copay then Coinsurance',
  NoCoverage = 'No Coverage',
}
